module.exports = __webpack_public_path__ + "static/media/picture.bab2ad35.svg";